import { StartrRoot } from "./Startr.styles"
import { Hero } from "./components/Hero"
import { Layout } from "components/Layout"
import { Header } from "components/Header"
import { Footer } from "components/Footer"
import { CustomerReview } from "./components/CustomerReview"
import { RecipeFooter } from "features/Recipes/components/RecipeFooter"
import { useTranslation } from "hooks/useTranslation"
import { ViewAllProducts } from "./components/ViewAllProducts"
import { FeedGreat } from "./components/FeedGreat"
export const Startr = () => {
    const header = <Header />
    const { t } = useTranslation()

    return (
        <StartrRoot>
            <Layout hideCTA header={header}>
              <Hero />  
              <CustomerReview />
              <ViewAllProducts />
              <FeedGreat />
              <RecipeFooter ctaLink='/meal-plan' cta={t('products:footer.cta1')} header={t('products:footer.title')}  />
              <Footer />
            </Layout>
        </StartrRoot>
    )
}